// extracted by mini-css-extract-plugin
export default {"panel":"ControlHVAC_panel__3QZu6","temperature":"ControlHVAC_temperature__MWRPf","off":"ControlHVAC_off__hvIr2","toggle":"ControlHVAC_toggle__MQWeE"};